module.exports = __webpack_public_path__ + "static/img/pic_setting_1.c5733aeb.png";